import { render, staticRenderFns } from "./PercentBar.vue?vue&type=template&id=68626b74&scoped=true"
import script from "./PercentBar.vue?vue&type=script&lang=js"
export * from "./PercentBar.vue?vue&type=script&lang=js"
import style0 from "./PercentBar.vue?vue&type=style&index=0&id=68626b74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68626b74",
  null
  
)

export default component.exports